import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';
import Skeleton from '@mui/material/Skeleton';
import StarRating from './StarRating/StarRating';

import { FaPhone } from '@react-icons/all-files/fa/FaPhone';
import { FaGlobe } from '@react-icons/all-files/fa/FaGlobe';
// ------------------------------------------------------------------------------------------

function CompanyDetailSection(props)
{
    
    return ( 
        <>
        { !props?.error && ( 
        <Paper sx={{ paddingTop: '30px', paddingBottom: '30px', marginBottom: '40px' }}>
            <Container maxWidth="lg">
                <Grid container spacing={4}>

                    { /* Logo section */ }
                    <Grid item md={2} lg={2} sx={{ display: { 'xs': 'none', 'md': 'block' }}} >
                        <div style={{ boxShadow: '10px 10px 42px -9px rgba(0,0,0,0.56)' }}>
                            { props.loading ? <Skeleton variant="rectangular" width="100%" height={170} /> : ( 
                                <img src={`https://api.workingfeedback.co.uk/company/${props?.company?.id}/logo/250x250`} alt="Company logo" style={{ maxWidth: '100%' }} />
                            )}
                        </div>
                    </Grid>

                    { /* Details section */ }
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Stack spacing={1}>

                            { /* Company name */ }
                            <Typography variant="h3" component="h2">{ props.loading ? <><Skeleton variant="text" /><Skeleton variant="text" /></> : props.company?.name }</Typography>

                            { /* Address */ }
                            <Typography variant="body">{ props.loading ? <Skeleton variant="text" /> : props.company?.address?.formatted }</Typography>

                            { /* Website and phone number */ }
                            <Stack direction={{ xs: "column", sm: "row" }} spacing={{ xs: 0, sm: 6 }}>
                                { props.company?.website?.length > 7 && ( 
                                    <Stack direction="row" spacing={1}>
                                        <FaGlobe />
                                        <Typography variant="body2"><Link href={`${props.company?.website}`} color="secondary" target="_blank">{ props.company?.website }</Link></Typography>
                                    </Stack>
                                )}
                                { props.company?.telephone?.length > 5 && (
                                    <Stack direction="row" spacing={1}>
                                        <FaPhone />
                                        <Typography variant="body2"><Link href={`tel:${props.company?.telephone}`} color="secondary">{ props?.company.telephone }</Link></Typography>
                                    </Stack>
                                )}                                                                
                            </Stack>

                        </Stack>
                    </Grid>

                    { /* Review section */ }
                    <Grid item md={4} lg={4} sx={{ display: { 'xs': 'none', 'md': 'block' }}}>
                        <Stack spacing={1}>                                    
                            <Typography variant="h5" component="h5">
                                { props.loading ? <Skeleton variant="text" /> : <>{ props.company?.reviews?.ratingWord } <span style={{ fontWeight: 'normal' }}>rating from { props.company?.reviews?.count } reviews</span></> }
                            </Typography>
                            <StarRating value={props.company?.reviews?.stars} size="large" />                            
                            <Typography variant="body2">
                            { props.loading && <><Skeleton variant="text" width={'60%'} /><Skeleton variant="text" width={'30%'} /></> }
                            { !props.loading && (  
                                <>
                                { props.company?.canCollectGoogle === true && props.company?.googleURL?.length > 1 && ( 
                                <a aria-label={`Google reviews for ${props?.company?.name}`} target="_blank" style={{ color: 'rgb(51, 102, 255)' }} rel="noreferrer" href={props?.company?.googleURL?.replace('writereview', 'reviews')}>+ { props.company?.reviews?.googleReviewsCount } reviews from Google<br /></a>
                                )}
                                <span style={{ fontWeight: 'bold' }}>{ props.company?.reviews?.grandTotal } total reviews</span>
                                </>
                            )}
                            </Typography>
                        </Stack>
                    </Grid>

                </Grid>                
            </Container>
        </Paper>
        )}
        </>
    )

}
export default CompanyDetailSection;